(function () {
    'use strict';

    angular.module("imApp").factory("searchStockService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1444,
                    parameters: parms || {}
                });
            },
            search: function (setting) {
                return $ihttp.post({
                    method: 462,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
